// extracted by mini-css-extract-plugin
module.exports = {"header":"Form_header__p0Xws","newDoc_group":"Form_newDoc_group__1FqyT","newDoc_checkbox":"Form_newDoc_checkbox__3o70Q","newDoc_label":"Form_newDoc_label__13e6Y"};